import { useEffect, useState } from 'react'
import { WAIT_GET_PRODUCT } from '~/graphqls/gqls'
import {
  waitGetProduct,
  waitGetProduct_itemModule_waitGetArtwork,
  ArtworkSendType,
  ArtworkSendStatus,
} from '~/graphqls/types'
import { useImperativeQuery } from '~/hooks/useImperativeQuery'
import { MyModal } from '../ui/MyModal'
import styled from 'styled-components'
import { MyBtn } from '~/components/ui/MyBtn'
import { CloseCircleOutlined } from '@ant-design/icons'
import Cookies from 'js-cookie'
import { GetProductDetailModal } from './GetProductDetailModal'
import { useValidateAuth } from '~/hooks/useValidateAuth'
import { useRouter } from 'next/router'

const StyledModal = styled(MyModal)`
  .ant-modal-content {
    border-radius: 0;
    background: none;
    box-shadow: none;
  }
  .ant-modal-body {
    padding: 0;
  }
  .modal-body {
    background: linear-gradient(180deg, #ffefe0 0%, #fff8f1 100%);
    backdrop-filter: blur(56px);
    border-radius: 16px;
    padding: 16px;
    text-align: center;
  }
`

export const GetProductModal: React.FC = () => {
  const [visible, setVisible] = useState(false)
  const [detailVisible, setDetailVisible] = useState(false)
  const router = useRouter()

  const { validateIsRealName, validateBindBankCard } = useValidateAuth()

  const [productInfo, setProductInfo] =
    useState<waitGetProduct_itemModule_waitGetArtwork>()

  const isAirDrop =
    productInfo?.type === ArtworkSendType.BLIND_BOX ||
    productInfo?.type === ArtworkSendType.CHOICE

  const isExpire = productInfo?.status === ArtworkSendStatus.CANCEL

  const getProductInfo = useImperativeQuery<waitGetProduct>(WAIT_GET_PRODUCT)

  const onClose = () => {
    Cookies.set('hidden-get-product-modal', String(true), {
      expires: new Date(new Date().getTime() + 2 * 60 * 60 * 1000),
    })

    setVisible(false)
  }

  const onClaim = () => {
    if (isExpire) {
      MyModal.info({
        title: isAirDrop ? '礼物领取已过期' : '提示',
        content: isAirDrop
          ? '抱歉，空投礼物领取时间已截止，已自动回收，不再进行二次补送，请您谅解。'
          : '预售作品已被领取',
        icon: '',
        maskStyle: {
          backgroundColor: 'rgba(0,0,0,0.8)',
        },
        width: 300,
        okText: '知道了',
        onOk: close => {
          close()
          onClose()
        },
      })
      return
    }
    if (validateIsRealName() && validateBindBankCard()) {
      setDetailVisible(true)
    }
  }

  useEffect(() => {
    if (Boolean(Cookies.get('hidden-get-product-modal')) === true) return

    if (['/settings/bank-card', '/setting/safety'].includes(router.pathname))
      return

    getProductInfo().then(data => {
      if (data.data.itemModule?.waitGetArtwork?.id) {
        setProductInfo(data.data.itemModule?.waitGetArtwork)
        setVisible(true)
      }
    })
  }, [router.asPath])

  return (
    <StyledModal
      visible={visible}
      onCancel={() => setVisible(false)}
      maskStyle={{
        backgroundColor: 'rgba(0,0,0,0.8)',
      }}
      closable={false}
      maskClosable={false}
      width={270}
      footer={null}
    >
      <div className="modal-body">
        {isAirDrop ? (
          <>
            <div className="text-neutrail-200 text-lg font-semibold mb-2">
              恭喜获得
            </div>
            <div className="text-neutrail-200 text-sm font-medium mb-2">
              一份空投礼物
            </div>
            <img
              className="mb-4 mx-auto block w-[142px]"
              src="/images/product/airdrop@2x.png"
              alt="airdrop"
            />
          </>
        ) : (
          <>
            <div className="text-neutrail-200 text-lg font-semibold mb-2">
              预售作品发放
            </div>
            <div className="text-neutrail-200 text-sm font-medium mb-2">
              {productInfo?.product?.name}
            </div>
            <img
              className="mb-4 mx-auto block rounded-lg"
              src={productInfo?.product?.artworkUrl || ''}
              alt={productInfo?.product?.name || ''}
            />
          </>
        )}

        <MyBtn
          className="!bg-neutral-200 !border-neutral-200 !text-neutral-800"
          onClick={onClaim}
          block
        >
          立即领取
        </MyBtn>
      </div>
      <div className="mt-8 mx-auto text-center">
        <CloseCircleOutlined
          onClick={onClose}
          className="!text-neutral-800"
          style={{
            fontSize: 24,
          }}
        />
      </div>
      {detailVisible && (
        <GetProductDetailModal
          visible={detailVisible}
          setVisible={setDetailVisible}
          data={productInfo as waitGetProduct_itemModule_waitGetArtwork}
        />
      )}
    </StyledModal>
  )
}
